import './appStoreLinks.less'

class AppStoreLinksController {
    constructor() {
        'ngInject';
    }
}

export const AppStoreLinksComponent = {
    name: 'appStoreLinks',
    component: {
        template: `
            <a class="apple" href="https://itunes.apple.com/us/app/mymedschedule-plus-med-reminder-pill-organizer/id1166318825" target="_blank">
                <img ng-src="/app/img/Download_on_the_App_Store_Badge_US-UK_135x40.svg" alt="Download on the App Store" />
            </a>
            <a class="google" href="https://play.google.com/store/apps/details?id=com.medactionplan.mymedscheduleplus&hl=en" target="_blank">
                <img ng-src="/app/img/google-play-badge_168x50.png" alt="Get it on Google Play" />
            </a>
        `,
        controller: AppStoreLinksController,
        bindings: {
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/appStoreLinks/appStoreLinks.component.js